// Entry point for the build script in your package.json

import "@hotwired/turbo-rails";
import "./controllers";
import * as bootstrap from "bootstrap";
import "@fortawesome/fontawesome-free/js/all.js";
import "trix";
import "@rails/actiontext";
import "chartkick/chart.js";

import "./src/jquery";
import "./src/jquery-ui";
import "./src/jquery.ui.autocomplete.html.js";

require("@nathanvda/cocoon");

window.Turbo = Turbo;

FontAwesome.config.mutateApproach = "sync";
